
import { ExtraFieldBooleanConfig } from "@/models/dossier-configs/extra-field-boolean-config";
import { DossierConfigService } from "@/services/dossier-config-service";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppExtraFieldBaseOptions from "./ExtraFieldBaseOptions.vue";
import { ExtraFieldsType } from "@/utils/models/extra-fields";

export default Vue.extend({
	data(){
		return {
			config: new ExtraFieldBooleanConfig(),
			langs: DossierConfigService.getLanguages().LanguageNames,
		};
	},
	props: {
		value: {
			type: Object as ()=>ExtraFieldBooleanConfig,
			required: true
		},
		optionsIndex: {
			type: Number,
			required: true
		},
		extraFieldsType: {
			type: String as ()=>ExtraFieldsType,
			required: true
		}
	},
	computed: {
		title():TranslateResult{
			return this.$ct("extra-field-bool-options", {index: this.optionsIndex});
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.config = new ExtraFieldBooleanConfig(this.value);
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", this.config);
			this.close();
		},
	},
	components: {
		AppExtraFieldBaseOptions
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
